import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type ManualLoadingOptions = {
  message?: string;
  showBrandLogo?: boolean;
};

@Injectable({
  providedIn: 'root'
})
export class SpinnerManualService {
  isLoading = new BehaviorSubject<boolean>(false);
  message = new BehaviorSubject<string>('');
  showBrandLogo = new BehaviorSubject<boolean>(false);

  setManualLoading(state: boolean, options?: ManualLoadingOptions): void {
    this.isLoading.next(state);
    if (state) {
      this.message.next(options?.message || '');
      this.showBrandLogo.next(options?.showBrandLogo === true);
      return;
    }

    this.message.next('');
    this.showBrandLogo.next(false);
  }

  show(): void {
    this.isLoading.next(true);
  }

  hide(): void {
    this.isLoading.next(false);
  }
}
